
const parseValue = (key,properties) =>{
  if (properties?.length === 0 ) return ''

  const foundKey = properties?.find((p) => p.key === key)
  if (!foundKey) return ''
  const parsedValue = foundKey.value !=='' ? JSON.parse(foundKey?.value) : ''

  return parsedValue?.values || ''
}


export {parseValue}